import { MutationTree } from 'vuex';
import { JobState } from './state';

export const mutations: MutationTree<JobState> = {
  setZipcode(state, zipcode: string) {
    state.zipcode = zipcode;
  },
  setScheduleType(state, scheduleType: string) {
    state.scheduleType = scheduleType;
  },
  setChildCount(state, childCount: number) {
    state.childCount = childCount;
  },
  setChildAges(state, childAges: number[]) {
    state.childAges = childAges;
  },
  setRequirements(state, requirements: string[]) {
    state.requirements = requirements;
  },
  setResponsibilities(state, responsibilities: string[]) {
    state.responsibilities = responsibilities;
  },
  setLanguages(state, languages: string[]) {
    state.languages = languages;
  },
  setTitle(state, title: string) {
    state.title = title;
  },
  setSimpleDescription(state, value: string) {
    state.simpleDescription = value;
  },
  setStartDate(state, startDate: string | null) {
    state.startDate = startDate;
  },
  setAiGenerated(state, payload: { aiGenerated: boolean; aiTitle: string; aiDescription: string }) {
    state.aiGenerated = payload.aiGenerated;
    state.aiTitle = payload.aiTitle;
    state.aiDescription = payload.aiDescription;
  },
};

export default mutations;
